<template>
  <div>
    <div class="mt-5">
      <h2 class="title is-4">
        {{ $t('admin.product.additionalResources.title') }}
      </h2>
      <span class="is-clickable" @click.prevent="toggleActive">
        {{ $t('admin.product.additionalResources.safetyImages') }}
      </span>
    </div>
    <additional-resources-modal :product="product" :active="active" @close="toggleActive" />
  </div>
</template>

<script>
import AdditionalResourcesModal from 'marketplace-front-core/components/admin/modals/AdditionalResourcesModal'
export default {
  components: {
    AdditionalResourcesModal
  },
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      active: false
    }
  },
  methods: {
    toggleActive () {
      this.active = !this.active
    }
  }
}
</script>
